import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const IntegrationCellWrapper = styled.div`
  display: grid;
  grid-template-areas:
    'image name badges'
    'image actions actions';
  grid-template-columns: 48px auto 1fr;
  column-gap: 10px;
  align-items: center;

  img {
    grid-area: image;
    width: 48px;
    height: 48px;
    object-fit: contain;

    ${mediaQuery.sm} {
      width: 36px;
      height: 36px;
    }
  }

  .badges {
    grid-area: badges;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }

  .actions {
    grid-area: actions;
    display: flex;
    align-items: center;
    gap: 5px;

    button {
      padding: 0;
      width: fit-content;
    }

    span {
      height: 16px;
      width: 16px;
    }

    div {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  p {
    grid-area: name;
    font-weight: bold;
    font-size: 18px;
    margin: 0;
  }
`;

export const HostfullyLinkContainer = styled.div`
  padding-left: 5px;
  border-left: 1px solid #1f1f1f;

  a {
    font-weight: bold;
  }
`;
